import { useEffect } from 'react';

export function usePageTitle(title) {
    useEffect(() => {
        console.log('setting title to:', title);
        document.title = title;
    }, [title]);
}